import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import { LinkProps } from 'next/link';

type Props = AnchorProps & {
  linkProps?: LinkProps;
};

const HomePageLink: React.FC<Props> = ({ children, linkProps, ...props }) => (
  <a {...props} aria-label="Go to the Homepage" href="/">
    {children}
  </a>
);

export default HomePageLink;
